export default __webpack_public_path__ + "static/media/mezcal2.683ecc76.jpg";